import { useEffect, useState } from 'react';
import {
  performanceApi,
  type PerformanceCampaignSummary,
  ApiError,
} from '@/services/api';
import { usePerformanceContext } from '../../PerformanceContext';

interface State {
  data: PerformanceCampaignSummary | null;
  loading: boolean;
  error: string | null;
  notFound: boolean;
}

export function useCampaignSummary(campaignId: string | undefined) {
  const { clientUid, dateFrom, dateTo } = usePerformanceContext();
  const [state, setState] = useState<State>({
    data: null,
    loading: false,
    error: null,
    notFound: false,
  });

  useEffect(() => {
    if (!clientUid || !campaignId) return;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null, notFound: false }));

    performanceApi
      .getCampaignSummary(campaignId, { clientUid, dateFrom, dateTo })
      .then((data) => {
        if (cancelled) return;
        setState({ data, loading: false, error: null, notFound: false });
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 404) {
          setState({ data: null, loading: false, error: null, notFound: true });
          return;
        }
        const msg = err instanceof ApiError ? err.body : String(err);
        setState({ data: null, loading: false, error: msg, notFound: false });
      });

    return () => {
      cancelled = true;
    };
  }, [clientUid, campaignId, dateFrom, dateTo]);

  return state;
}
